const groupBy = (arrayOfObjects, key) =>
  arrayOfObjects.reduce((acc, item) => ({
    ...acc,
    [item[key]]: [...(acc[item[key]] || []), item],
  }), {});

export default groupBy;
